// Bloque N-mínimo, sesión 3 (docs/PLAN_BLOQUE_N.md): arma la regla jsonb que
// offer_fit_preview() / offer_fit_rules.rule esperan (ver
// supabase/schemas/15_raftel_bloque_n.sql) a partir de lo que el paso
// "Cliente ideal" del asistente captura. Una sola cláusula por ahora (el
// asistente de N-mínimo no ofrece "o esto o aquello" todavía).

export type FitClauseDraft = {
  sectores: string[];
  scianIncluir: string; // separado por comas, ej. "7225%, 7224%"
  scianExcluir: string;
  empMin: string; // texto del input; "" = sin mínimo
  nombreIncluir: string; // regex opcional
  nombreExcluir: string;
};

export const EMPTY_FIT_CLAUSE: FitClauseDraft = {
  sectores: [],
  scianIncluir: "",
  scianExcluir: "",
  empMin: "",
  nombreIncluir: "",
  nombreExcluir: "",
};

const splitList = (s: string) =>
  s
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);

/** true si la cláusula tiene al menos una condición capturada (para no pedir preview vacío). */
export const hasFitCondition = (c: FitClauseDraft): boolean =>
  c.sectores.length > 0 ||
  splitList(c.scianIncluir).length > 0 ||
  splitList(c.scianExcluir).length > 0 ||
  c.empMin.trim() !== "" ||
  c.nombreIncluir.trim() !== "" ||
  c.nombreExcluir.trim() !== "";

/** Arma el jsonb que offer_fit_preview()/offer_fit_matches() esperan. */
export const buildFitRule = (
  c: FitClauseDraft,
  excluirSectorPublico: boolean,
): Record<string, unknown> => {
  const clause: Record<string, unknown> = {};
  if (c.sectores.length) clause.sectores = c.sectores;
  const scianIncluir = splitList(c.scianIncluir);
  if (scianIncluir.length) clause.scian_incluir = scianIncluir;
  const scianExcluir = splitList(c.scianExcluir);
  if (scianExcluir.length) clause.scian_excluir = scianExcluir;
  const empMin = Number(c.empMin);
  if (c.empMin.trim() !== "" && Number.isFinite(empMin) && empMin > 0)
    clause.emp_min = empMin;
  if (c.nombreIncluir.trim()) clause.nombre_incluir = c.nombreIncluir.trim();
  if (c.nombreExcluir.trim()) clause.nombre_excluir = c.nombreExcluir.trim();
  return {
    excluir_sector_publico: excluirSectorPublico,
    clauses: Object.keys(clause).length ? [clause] : [],
  };
};
